module.exports = __webpack_public_path__ + "img/logo-w.b2584fe5.png";